
/* injects from baggage-loader */
require('./style.scss');

import React from 'react'
import PropTypes from 'prop-types'
import { t } from "../../../../dev/helpers/translator";

export const BonusesNotification = ({ bonuses, currency }) => {
    return (
        <>
            <div>
                {t('You have the following free bet bonuses available')}
            </div>
            <br />
            <div className='bonuses-list'>
                {
                    bonuses.map(bonus => <div className='bold bonus-item'>{bonus.amount} {currency}</div>)
                }
            </div>
        </>
    )
}

BonusesNotification.propTypes = {
    bonuses: PropTypes.array,
    currency: PropTypes.string
}